// PLAN (Sekundärfarbe) + ROLLE (Primärfarbe) als Kürzel-Badges mit Volltext-Tooltip.
export const PLAN_LABELS = {
  EIN: "Einzelnutzung",
  UNT: "Unternehmer",
  MAN: "Mandant",
  STB: "Steuerberater",
};
export const ROLLE_LABELS = {
  EIG: "Hauptbesitzer (Zahler)",
  MAN: "Mandant",
  MAA: "Mitarbeiter mit Admin-Rechten",
  MAB: "Mitarbeiter",
  MAM: "Kanzlei-Mitarbeiter (Mandantenbearbeitung)",
};

export function PlanRoleBadges({ plan, rolle, className = "" }) {
  return (
    <span className={`inline-flex flex-wrap items-center gap-1 ${className}`}>
      {plan && (
        <span
          title={`Plan: ${PLAN_LABELS[plan] || plan}`}
          data-testid="plan-badge"
          className="inline-block rounded-full bg-secondary text-secondary-foreground px-2 py-0.5 text-[10px] font-semibold whitespace-nowrap cursor-default select-none"
        >
          {plan}
        </span>
      )}
      {rolle && (
        <span
          title={`Rolle: ${ROLLE_LABELS[rolle] || rolle}`}
          data-testid="rolle-badge"
          className="inline-block rounded-full bg-primary text-primary-foreground px-2 py-0.5 text-[10px] font-semibold whitespace-nowrap cursor-default select-none"
        >
          {rolle}
        </span>
      )}
    </span>
  );
}
